import React from 'react'
import CustomToast from '@components/customToast'
import { toast } from 'react-toastify'

export default function showToast(type, message, error) {
  toast(<CustomToast type={type} message={message} error={error} />)
}
